export const APP_NAME = 'LendingOne';
export const HUMAN_APP_NAME = 'LendingOne'
export const EMAIL_FROM = 'credentials@lendingone.com';

export const IS_LENDINGONE = true;
